<template>
  <div class="app-loading__overlay" v-if="active">
    <div class="app-loading__content">
      <div class="app-loading__text">
        <p class="app-loading__title t-label t-label--dark">{{ title }}</p>
        <slot />
      </div>

      <app-spinner class="app-loading__spinner" :block="true" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.app-loading__overlay {
  position: fixed;
  z-index: 999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #2f2e2efa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-loading__text {
  text-align: center;
  margin-bottom: 2em;

  :not(.app-loading__title) {
    color: #9b9b9b;
  }
}

.app-loading__title {
  color: #fff;
  font-weight: 600;
  margin-bottom: 0.6em;
}
</style>
